import PropTypes from 'prop-types'
import React from 'react'
import config from 'config/products'
import CheckBox from 'Form/CheckBox'
import css from './AgeVerification.css'

const AgeVerificationCheckBox = ({ disabled, onCheckBoxChange, _onTooltipVisibleChange, showError, _tooltipVisible }) => (
  <div className={css.checkbox}>
    <CheckBox
      label={`This item is age restricted, please confirm you’re over ${config.restrictedAge}`}
      disabled={disabled}
      onChange={onCheckBoxChange}
    />
    {showError ? <div className={css.error}>Error verifying age</div> : ''}
  </div>
)

AgeVerificationCheckBox.propTypes = {
  disabled: PropTypes.bool,
  onCheckBoxChange: PropTypes.func,
  _onTooltipVisibleChange: PropTypes.func,
  showError: PropTypes.bool,
  _tooltipVisible: PropTypes.bool,
}

AgeVerificationCheckBox.defaultProps = {
  disabled: false,
  onCheckBoxChange: () => { },
  _onTooltipVisibleChange: () => { },
  showError: false,
  _tooltipVisible: false,
}

export { AgeVerificationCheckBox }
